<template>
  <div class="search-input">
    <div class="icon h-i-center">
      <i class="material-icons">
        search
      </i>
    </div>
    <input
      @input="onInput($event.target.value)"
      :value="value"
      class="h-empty-input"
      type="text"
      :placeholder="$ml.get(`Search`)"
    >
  </div>
</template>

<script>
export default {
  data () {
    return {
      flag: false,
      timOut: false,
      val: '',

    }
  },
  props: {
    value: {},
    secDelay: {
      type: Number,
      default: 2
    },
    delayed: {
      default: false,
      type: Boolean,
    }
  },
  methods: {
    onInput (val) {
      this.val = val;
      
      if(this.delayed) {
        if (this.timOut) {
          clearTimeout(this.timOut);
        }

        this.timOut = setTimeout(() => {
          this.$emit('input', this.val)
        }, this.secDelay * 1000);
      } else {
        this.$emit('input', this.val)
      }
    },
  }
}
</script>

<style lang="scss" scoped>

.search-input {
  background: #F3F3F3;
  border-radius: 5px;
  position: relative;

  .icon {
    position: absolute;
    left: 5px;
    width: 30px;
    top: 0;
    height: 100%;
    color: #8B8D91;
  }

  input {
    padding: 10px 10px;
    padding-left: 40px;
    width: 100%;
    transition: padding-left 0.3s ease;

    &::placeholder {
      color: #8B8D91;
      font-size: 14px;
    }

    &:focus {
      padding-left: 50px;
    }
  }
}

</style>
